import { Typography } from '@mui/material';
import styled from 'styled-components';

export const AddToAccountBodyMessage = styled(Typography)`
  text-align: center;
`;
